import { render, staticRenderFns } from "./Benefactor.vue?vue&type=template&id=81c391c4&"
import script from "./Benefactor.vue?vue&type=script&lang=js&"
export * from "./Benefactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c391c4')) {
      api.createRecord('81c391c4', component.options)
    } else {
      api.reload('81c391c4', component.options)
    }
    module.hot.accept("./Benefactor.vue?vue&type=template&id=81c391c4&", function () {
      api.rerender('81c391c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/Benefactor.vue"
export default component.exports